import "./MainButton.css";

const MainButton = ({
  children,
  onClick,
  type = "button",
  className = "",
  ...props
}) => {
  return (
    <button
      type={type}
      onClick={onClick}
      className={`main-btn ${className}`}
      {...props}
    >
      {children}
    </button>
  );
};

export default MainButton;
